export enum AudienceNetworkPositionEnum {
    CLASSIC = 'classic',
    INSTREAM_VIDEO = 'instream_video', // not on facebook api
    REWARDED_VIDEO = 'rewarded_video'
}
export enum OldAudienceNetworkPositionEnum {
    classic,
    instream_video,
    rewarded_video
}